/******************************************************************************
 * @preserve Copyright (c) 2012 Amazon.com, Inc. All rights reserved.         *
 ******************************************************************************/
import './send-to-kindle-popup.css';
import {getSupportCountryCodeList, getCountryName, getCountryIconPath} from "../../src-worker/s2k-i18nInfoHelper";
import {submitFeedback} from "../../src-worker/s2k-feedback";
import {MetricsNames} from "../../src-logic/metrics/metrics";
import {MAX_DEVICE_NAME_WIDTH} from "../../src-common/constants";

/**
 * The current support item types of country list in country picker
 * @type {{SELECTED: string, ENTRY: string, UNSELECTED: string}}
 */
const CountryItemType = {
    ENTRY: 'Entry', SELECTED: 'Selected', UNSELECTED: 'Unselected',
};

jQuery(function ($) {
    let $S2K = window.$SendToKindle = {
        // ################################ Constants ################################
        ID_POP_UP: "s2k-popup",
        ID_POP_UP_SPINNER_CONTAINER: "s2k-popup-spinner-container",
        ID_NAV_BAR: "s2k-popup-nav-bar-container",
        ID_NAV_BAR_BACK: "s2k-popup-back",
        ID_AUTHED_DIV: "s2k-popup-authenticated-page",
        ID_UN_AUTHED_DIV: "s2k-popup-unauthenticated-page",
        ID_COUNTRY_PICKER_DIV: "s2k-popup-country-picker-page",
        ID_COUNTRY_LIST_CONTAINER: "s2k-popup-country-list-container",
        ID_COUNTRY_PICKER_CONTINUE_BUTTON: "s2k-popup-country-picker-continue",
        ID_SEND_BUTTON: "s2k-popup-send",
        ID_PREVIEW_BUTTON: "s2k-popup-preview",
        ID_SEND_SELECTED_BUTTON: "s2k-popup-selected",
        ID_HISTORY_BUTTON: "s2k-popup-history",
        ID_SETTINGS_BUTTON: "s2k-popup-settings",
        ID_FEEDBACK_BUTTON: "s2k-popup-feedback",
        ID_SETTINGS_ICON: "s2k-popup-main-item-settings-icon",
        ID_SETTINGS_CORNER_ALERT: "s2k-popup-settings-corner-alert",
        ID_SETTINGS_DIV: "s2k-popup-settings-page",
        ID_USERINFO_NAME_DIV: "s2k-popup-settings-user-name",
        ID_USERINFO_COUNTRY_DIV: "s2k-popup-settings-user-country",
        ID_ADD_TO_LIB_SWITCHER_CONTAINER: "s2k-popup-settings-add-to-lib-switcher-container",
        ID_ADD_TO_LIB_SWITCHER: "s2k-popup-settings-add-to-lib-switcher",
        ID_DEVICES_LIST_SECTION_DIV: "s2k-popup-settings-add-to-lib-devices-section",
        ID_DEVICES_LIST_CONTAINER: "s2k-popup-settings-devices-list-container",
        ID_DEVICES_LIST_NO_DEVICE_TEXT: "s2k-popup-settings-devices-list-no-devices-text",
        ID_DEVICES_LIST_INLINE_ALERT: "s2k-popup-settings-add-to-lib-devices-inline-alert",
        ID_COMPLEXITY_WARNINGS_SWITCHER: "s2k-popup-settings-complexity-warnings-switcher",
        ID_SIGN_OUT_CONTENT_DIV: "s2k-popup-settings-logout-content",
        ID_SIGN_OUT_SPINNER_DIV: "s2k-popup-settings-logout-spinner",
        ID_SIGN_OUT_BUTTON: "s2k-popup-settings-logout-button",
        ID_FEEDBACK_DIV: "s2k-popup-feedback-page",
        ID_FEEDBACK_INPUT_CONTAINER: "s2k-popup-feedback-input-container",
        ID_FEEDBACK_TEXTAREA: "s2k-popup-feedback-textarea",
        ID_FEEDBACK_SUBMIT_BUTTON: "s2k-popup-feedback-submit",
        ID_FEEDBACK_FINISH_TEXT: "s2k-popup-feedback-finish-text",

        POP_UP_SPINNER_CONTAINER_DEFAULT_WIDTH: 215,
        POP_UP_SPINNER_CONTAINER_DEFAULT_HEIGHT: 258,

        // ################################ Members ################################
        isSelected: false, // Stand for if there's any content is selected
        pageStack: [], // The stack of UI pages div id
        currentDivId: undefined, // Stand for the div of current visible UI
        currentCountryCode: "us", // Stand for the country code of current user, default is us.
        selectedCountryCode: "us", // The country code selected by user, it's used for show in the country picker entry.(default is same as currentCountryCode)
        actionAfterSelectCountry: undefined,  // To store the action user would like to do after select a country in country picker (signIn, password, register)
        isAddToLib: true,  // The switcher status of add-to-lib switcher
        devicesList: [], // Devices list of current user
        selectedDevicesList: [], // Selected devices list of current user
        rating: 0, // The rating from user

        // ################################ Methods ################################
        /**
         * Bootstrap the popup.
         */
        bootstrap: function () {
            // Show loading spinner when initializing;
            $S2K.hidePopupSpinner(false, $S2K.POP_UP_SPINNER_CONTAINER_DEFAULT_HEIGHT, $S2K.POP_UP_SPINNER_CONTAINER_DEFAULT_WIDTH);

            // Load user preferences ()
            $S2K.loadUserPreferences();

            // Load localization.
            $S2K.loadStrings();

            // Load A11y string.
            $S2K.loadA11yString();

            // Load shortcuts.
            $S2K.loadShortcuts();

            // Register events.
            $S2K.registerEvents();

            $S2K.onCheckAuth(true, function (isAuthed) {
                // Hide loading spinner when initializing;
                $S2K.hidePopupSpinner(true);

                // Change UI based on the auth status
                $S2K.changeUIWithId(isAuthed ? $S2K.ID_AUTHED_DIV : $S2K.ID_UN_AUTHED_DIV);

                if (isAuthed) {
                    // Check for selection if user is authed.
                    $S2K.checkSelected();
                }
            });
        },

        /**
         * Register all events.
         */
        registerEvents: function () {
            window.addEventListener("resize", $S2K.onResize);
            // Nav bar
            $("#s2k-popup-close").on("click", $S2K.onClose);
            $("#s2k-popup-back").on("click", $S2K.onBack);
            // Country picker
            $("#s2k-popup-country-picker-continue").on("click", $S2K.onCountryPickerContinue);
            // UnAuth page
            $("#s2k-popup-sign-in").on("click", $S2K.onSignIn);
            $("#s2k-popup-forgot-password").on("click", $S2K.onForgotPassword);
            $("#s2k-popup-create-account").on("click", $S2K.onCreateAccount);
            // Authed page
            $("#" + $S2K.ID_SEND_BUTTON).on("click", $S2K.onSendToKindle);
            $("#" + $S2K.ID_PREVIEW_BUTTON).on("click", $S2K.onPreview);
            $("#" + $S2K.ID_SEND_SELECTED_BUTTON).on("click", $S2K.onSendSelected);
            $("#" + $S2K.ID_SETTINGS_BUTTON).on("click", $S2K.onSettings);
            $("#" + $S2K.ID_HISTORY_BUTTON).on("click", $S2K.onHistory);
            $("#" + $S2K.ID_FEEDBACK_BUTTON).on("click", $S2K.onFeedback);
            // Feedback page
            $("#" + $S2K.ID_FEEDBACK_SUBMIT_BUTTON).on("click", $S2K.onSubmitFeedback);
            // Settings page
            $("#" + $S2K.ID_ADD_TO_LIB_SWITCHER_CONTAINER).on("click", $S2K.onAddToLibChange);
            $("#" + $S2K.ID_SIGN_OUT_BUTTON).on("click", $S2K.onSignOut);
        },

        /**
         * Load user preferences, include
         * 1. current country user selected (default: us).
         */
        loadUserPreferences: function () {
            // Call service worker to get current country
            chrome.runtime.sendMessage({"action": "get-current-country"}, function (countryCode) {
                $S2K.currentCountryCode = countryCode;
            });

            // Read the status of the switch of `add to lib`.
            chrome.runtime.sendMessage({action: "get-archive-switcher"}, function (archive) {
                $S2K.isAddToLib = archive;
                // Get selected device list
                chrome.runtime.sendMessage({action: "get-selected-devices-list"}, function (deviceList) {
                    $S2K.selectedDevicesList = deviceList || [];
                    if (!archive) {
                        // Show alert and disable send while the selected there's no devices is selected and archive is off
                        $S2K.hideNonDevicesSelectedAlert($S2K.selectedDevicesList.length > 0);
                    }
                });
            });
        },

        /**
         * Load localization for all text attributes.
         */
        loadStrings: function () {
            $.each($("[s2k-string]"), function () {
                let $n = $(this);
                $n.text(chrome.i18n.getMessage($n.attr("s2k-string")));
            });
        },

        /**
         * Load localization for all a11y-label attributes.
         */
        loadA11yString: function () {
            $.each($("[s2k-aria]"), function () {
                let $n = $(this);
                $n.attr("aria-label", chrome.i18n.getMessage($n.attr("s2k-aria")));
            });
        },

        /**
         * Load shortcuts.
         */
        loadShortcuts: function () {
            $.each($("[s2k-shortcut]"), function () {
                let $n = $(this);
                chrome.storage.sync.get($n.attr("s2k-shortcut"), function (items) {
                    $S2K.updateShortcut(items[$n.attr("s2k-shortcut")], $n);
                });
            });
        },

        /**
         * Update the shortcut displayed.
         * @param shortcut  Configured Shortcut
         * @param element   UI Element
         */
        updateShortcut: function (shortcut, element) {
            if (shortcut) {
                let shortcutText = "";

                // Set text for control keys.
                if (shortcut.control) {
                    shortcutText += chrome.i18n.getMessage("kbsCtrl") + " + ";
                }

                if (shortcut.shift) {
                    shortcutText += chrome.i18n.getMessage("kbsShift") + " + ";
                }

                if (shortcut.alt) {
                    shortcutText += chrome.i18n.getMessage("kbsAlt") + " + ";
                }

                // Set key code.
                if (shortcut.key > 47 && shortcut.key < 91) {
                    shortcutText += String.fromCharCode(shortcut.key);
                } else if (shortcut.key > 36 && shortcut.key < 41) {
                    switch (shortcut.key) {
                        case 37:
                            shortcutText += chrome.i18n.getMessage("kbsArrowLeft");
                            break;
                        case 38:
                            shortcutText += chrome.i18n.getMessage("kbsArrowUp");
                            break;
                        case 39:
                            shortcutText += chrome.i18n.getMessage("kbsArrowRight");
                            break;
                        case 40:
                            shortcutText += chrome.i18n.getMessage("kbsArrowDown");
                            break;
                    }
                } else {
                    shortcutText += "F" + (shortcut.key - 111);
                }

                // Set shortcut text.
                element.text(shortcutText);
            }
        },

        /**
         * Check for a text selection.
         */
        checkSelected: function () {
            // Default is disabled
            let sendSelectedBtn = $("#" + $S2K.ID_SEND_SELECTED_BUTTON);
            sendSelectedBtn.attr('disabled', true);
            chrome.tabs.query({active: true, lastFocusedWindow: true}, function (tabs) {
                let tab = tabs[0];
                if (tab) {
                    chrome.tabs.sendMessage(tab.id, {"action": "text-selected"}, function (response) {
                        if (response && response.action === "text-selected") {
                            if (response.isSelected === true) {
                                $S2K.isSelected = true;
                                sendSelectedBtn.attr('disabled', false);
                            } else {
                                $S2K.isSelected = false;
                                sendSelectedBtn.attr('disabled', true);
                            }
                        }
                    });
                }
            });
        },

        // ################################ Event Handlers ################################
        /**
         * Extract and send to a Kindle device.
         */
        onSendToKindle: function () {
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: MetricsNames["pop-main-send-click"]
                }
            });
            // Check auth status before send
            $S2K.onCheckAuth(false, function (isAuthed) {
                if (isAuthed) {
                    chrome.runtime.sendMessage({"action": "extract", "preview": false, "selected": false}, function () {
                        // Close window.
                        $S2K.onClose();
                    });
                } else {
                    // Change to un authed UI
                    $S2K.changeUIWithId($S2K.ID_UN_AUTHED_DIV, false);
                }
            });
        },

        /**
         * Extract and send to a Kindle device.
         */
        onSendSelected: function () {
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: MetricsNames["pop-main-send-sel-click"]
                }
            });
            // Check auth status before send
            $S2K.onCheckAuth(false, function (isAuthed) {
                if (isAuthed) {
                    chrome.runtime.sendMessage({"action": "extract", "preview": false, "selected": $S2K.isSelected}, function () {
                        // Close window.
                        $S2K.onClose();
                    });
                } else {
                    // Change UI based on the auth status
                    $S2K.changeUIWithId($S2K.ID_UN_AUTHED_DIV, false);
                }
            });
        },

        /**
         * Extract and redirect to Kindle Viewer
         * on Amazon.
         */
        onPreview: function () {
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: MetricsNames["pop-main-preview-click"]
                }
            });
            // Check auth status before send
            $S2K.onCheckAuth(false, function (isAuthed) {
                if (isAuthed) {
                    chrome.runtime.sendMessage({"action": "extract", "preview": true, "selected": $S2K.isSelected}, function () {
                        // Close window.
                        $S2K.onClose();
                    });
                } else {
                    // Change UI based on the auth status
                    $S2K.changeUIWithId($S2K.ID_UN_AUTHED_DIV, false);
                }
            });
        },

        /**
         * Request Device list and jump to settings page
         */
        onSettings: function () {
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: MetricsNames["pop-main-setting-click"]
                }
            });
            // Show spinner
            $S2K.hidePopupSpinner(false);
            // Check auth status before send
            $S2K.onCheckAuth(false, function (isAuthed) {
                if (isAuthed) {
                    // Config Settings page first
                    $S2K.loadSettingsPage(function () {
                        // Hide spinner
                        $S2K.hidePopupSpinner(true);
                        // Jump to settings page after load complete
                        $S2K.changeUIWithId($S2K.ID_SETTINGS_DIV, false);
                    });
                } else {
                    // Hide spinner
                    $S2K.hidePopupSpinner(true);
                    // Kick out user to sign in page if auth check failed
                    $S2K.changeUIWithId($S2K.ID_UN_AUTHED_DIV);
                }
            });
        },

        /**
         * Navigate to feedback page
         */
        onFeedback: function () {
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: MetricsNames["pop-main-feedback-click"]
                }
            });
            // Check auth status before send
            $S2K.onCheckAuth(false, function (isAuthed) {
                if (isAuthed) {
                    // Load feedback page
                    $S2K.loadFeedBackPage("init");
                    // Jump to feedback page after load complete
                    $S2K.changeUIWithId($S2K.ID_FEEDBACK_DIV, false);
                } else {
                    // Kick out user to sign in page if auth check failed
                    $S2K.changeUIWithId($S2K.ID_UN_AUTHED_DIV, false);
                }
            });
        },

        /**
         * Open history view.
         */
        onHistory: function () {
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: MetricsNames["pop-main-history-click"]
                }
            });
            // Check auth status before open history
            $S2K.onCheckAuth(false, function (isAuthed) {
                if (isAuthed) {
                    // Show history view
                    chrome.runtime.sendMessage({"action": "show-history"}, function () {
                        // Close window.
                        $S2K.onClose();
                    });
                } else {
                    // Change UI based on the auth status
                    $S2K.changeUIWithId($S2K.ID_UN_AUTHED_DIV, false);
                }
            });
        },

        /**
         * Popup window resize
         */
        onResize: function () {
            const body = document.body;
            if (document.documentElement.scrollHeight > window.innerHeight + 1) {
                body.classList.remove("body-rightPadding");
            } else {
                body.classList.add("body-rightPadding");
            }
        },

        /**
         * Close popup window
         */
        onClose: function () {
            // Close popup
            window.close();
        },

        /**
         * Back to previous popup window
         */
        onBack: function () {
            // Remove last UI div id from page stack
            $S2K.pageStack.pop();
            $S2K.changeUIWithId($S2K.pageStack[$S2K.pageStack.length - 1], true);
        },

        /**
         * Nav to country picker page
         * @param {"sign-in" | "create-account"| "forgot-password"} action The action to do after select country
         */
        onJumpToCountryPicker: function (action) {
            // Store next action for 'continue button'
            $S2K.actionAfterSelectCountry = action;
            // Set the selected country to current country as default
            $S2K.selectedCountryCode = $S2K.currentCountryCode;
            // Config country list, after jump will only have an entry item of current country in list
            $S2K.loadEntryCountryList(action);
            // Change UI to country picker page.
            $S2K.changeUIWithId($S2K.ID_COUNTRY_PICKER_DIV, false);
        },

        /**
         * Show country list after user click the country entry in country picker page
         */
        onCountryEntryItemClick: function () {
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: MetricsNames["pop-country-single-entry-click"]
                }
            });
            // Config country list, need to generate whole country list.
            $S2K.loadFullCountryList();
            // Set A11y focus
            $S2K.updateA11yFocus($S2K.ID_COUNTRY_LIST_CONTAINER);
        },

        /**
         * Click action of selected/uselected country item in country list
         */
        onCountryItemClick: function () {
            // Need to remove all other countries in list and create an entry item of current selected country
            $S2K.loadEntryCountryList();
            // Set A11y focus
            $S2K.updateA11yFocus($S2K.ID_COUNTRY_LIST_CONTAINER);
        },

        /**
         * Save the change of country, reload the popup after saving
         */
        onCountryPickerContinue: function () {
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: MetricsNames["pop-country-picker-continue-click"]
                }
            });
            // Change current country
            $S2K.currentCountryCode = $S2K.selectedCountryCode;
            // Show loading spinner when get auth related Url;
            $S2K.hidePopupSpinner(false);
            // Save country change to local storage
            chrome.runtime.sendMessage({
                "action": "set-current-country", "currentCountry": $S2K.selectedCountryCode
            }, function () {
                // Open popup for user required action
                chrome.runtime.sendMessage({"action": $S2K.actionAfterSelectCountry}, function () {
                    // Show loading spinner when get auth related Url;
                    $S2K.hidePopupSpinner(true);
                    // Close popup
                    window.close();
                });
            });
        },

        /**
         * Open sign in page and close popup
         */
        onSignIn: function () {
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: MetricsNames["pop-unauth-sign-in-btn-click"]
                }
            });
            // Jump to country picker to choose a country to sign in
            $S2K.onJumpToCountryPicker("sign-in");
        },

        /**
         * Open forgot password page and close popup
         */
        onForgotPassword: function () {
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: MetricsNames["pop-unauth-psw-btn-click"]
                }
            });
            // Jump to country picker to choose a country to reset password
            $S2K.onJumpToCountryPicker("forgot-password");
        },

        /**
         * Open create new account page and close popup
         */
        onCreateAccount: function () {
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: MetricsNames["pop-unauth-reg-btn-click"]
                }
            });
            // Jump to country picker to choose a country to create a new account
            $S2K.onJumpToCountryPicker("create-account");
        },

        /**
         * The handler when add-to-lib switcher status changed
         */
        onAddToLibChange: function () {
            let switcher = $('#' + $S2K.ID_ADD_TO_LIB_SWITCHER);
            // Since the click event is from container, the status of switcher is not changed, we need to change it manually
            $S2K.isAddToLib = !switcher.prop("checked");
            switcher.prop("checked", $S2K.isAddToLib);
            // Set A11y status
            $(this).attr("aria-checked", $S2K.isAddToLib);

            // Metrics
            let metricsMsg = $S2K.isAddToLib ? MetricsNames["pop-setting-arch-on"] : MetricsNames["pop-setting-arch-off"];
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: metricsMsg
                }
            });
            // Update cache
            chrome.runtime.sendMessage(
                {
                    action: "set-archive-switcher",
                    data: {archive: $S2K.isAddToLib}
                }
            );
            // Since `add to lib` status is changed, need trigger changes of device list section
            $S2K.configDeviceListSection();
        },

        /**
         * SignOut
         */
        onSignOut: function () {
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: MetricsNames["pop-setting-logout-click"]
                }
            });
            // Show spinner
            $S2K.hideSignOutSpinner(false);
            // Call sign-out url
            chrome.runtime.sendMessage({"action": "sign-out"}, function () {
                // sign out success, kick user out to sign page
                $S2K.changeUIWithId($S2K.ID_UN_AUTHED_DIV, false);
                // Hide spinner
                $S2K.hideSignOutSpinner(true);
            });
        },

        // ################################ Authentication ################################
        /**
         * Open sign in page and close popup
         * @param useCache A bool value to show if the func need to get auth status from cache
         * @param callback a call back function after checked auth, will contain a param shows if it is authed
         */
        onCheckAuth: function (useCache, callback) {
            // Inject the S2K extension logic.
            chrome.runtime.sendMessage({"action": "check-auth", "useCache": useCache}, function (res) {
                // Close popup
                callback(res.data.isAuthed);
            });
        },

        /**
         * Determine which UI to show based on Auth status
         * @param idOfDiv The id Of div need to be shown
         * @param fromBack To identify is the UI change is from `back` action
         */
        changeUIWithId: function (idOfDiv, fromBack) {
            if (idOfDiv) {
                const oldDiv = document.getElementById($S2K.currentDivId);
                const newDiv = document.getElementById(idOfDiv);
                // Check if  new Div is existed
                if (newDiv) {
                    // Config navigation bar based on new div to show
                    $S2K.configNavBar(idOfDiv);
                    // Bottom PaddingAuthenticated page is different with others
                    const popupDiv = document.getElementById($S2K.ID_POP_UP);
                    if (idOfDiv !== $S2K.ID_AUTHED_DIV) {
                        popupDiv.classList.remove("s2k-popup-authenticated-padding");
                    } else {
                        popupDiv.classList.add("s2k-popup-authenticated-padding");
                    }
                    // Hide current div if existed
                    if (oldDiv) {
                        oldDiv.classList.add("s2k-hide");
                    }
                    // Show new div
                    newDiv.classList.remove("s2k-hide");
                    // Set A11y focus
                    $S2K.updateA11yFocus(idOfDiv);

                    // Add current div to the UI stack if not from `back` action
                    if (!fromBack) {
                        $S2K.pageStack.push(idOfDiv);
                    }
                    $S2K.currentDivId = idOfDiv;
                    // Need resize container after change UI
                    $S2K.resizePopup();
                }
            }
        },

        /**
         * Re-size the body and html to match size ofcurrent div
         */
        resizePopup() {
            const currentDiv = document.getElementById($S2K.currentDivId);
            // Fix popup size based on the visible UI
            $(document.body).height(currentDiv.offsetHeight);
            $(document.documentElement).height(currentDiv.offsetHeight);
        },

        /**
         *
         * Determine the nav bar content based on current UI
         * @param idOfDiv The id Of div need to be shown
         */
        configNavBar: function (idOfDiv) {
            let needShow = false;
            switch (idOfDiv) {
                case $S2K.ID_UN_AUTHED_DIV:
                case $S2K.ID_COUNTRY_PICKER_DIV:
                case $S2K.ID_SETTINGS_DIV:
                case $S2K.ID_FEEDBACK_DIV:
                    needShow = true;
                    break;
                case $S2K.ID_AUTHED_DIV:
                    needShow = false;
                    break;
            }
            const navBarDiv = document.getElementById($S2K.ID_NAV_BAR);
            // Change the visibility of Navbar
            if (needShow) {
                navBarDiv.classList.remove("s2k-hide");
            } else {
                navBarDiv.classList.add("s2k-hide");
            }

            let backDiv = document.getElementById($S2K.ID_NAV_BAR_BACK);
            // Change the visibility of Left button
            if (idOfDiv === $S2K.ID_UN_AUTHED_DIV) {
                backDiv.classList.add("s2k-hide");
            } else if (idOfDiv !== $S2K.ID_AUTHED_DIV) {
                // For every other page other than operation menu, show back button
                backDiv.classList.remove("s2k-hide");
            }
        },

        // ################################ Authed Page ################################
        /**
         * Change disable status of buttons related to send action
         * @param {boolean} disable Whether need to disable buttons related to send action
         */
        disableSendAction: function (disable) {
            let sendBtn = $('#' + $S2K.ID_SEND_BUTTON);
            let previewBtn = $('#' + $S2K.ID_PREVIEW_BUTTON);
            let sendSelectedBtn = $("#" + $S2K.ID_SEND_SELECTED_BUTTON);
            if (disable) {
                // Disable send button
                sendBtn.attr('disabled', true);
                // Disable preview button
                previewBtn.attr('disabled', true);
                // Disable send selected button
                sendSelectedBtn.attr('disabled', true);
            } else {
                // Enable send button
                sendBtn.attr('disabled', false);
                // Enable preview button
                previewBtn.attr('disabled', false);
                // Enable send selected button while some text are selected
                if ($S2K.isSelected) {
                    sendSelectedBtn.attr('disabled', false);
                }
            }
        },

        // ################################ Country Picker ################################
        /**
         * Load country list with only one entry item of current country
         */
        loadEntryCountryList: function () {
            // Get entry item with current country
            let entryItemDiv = $S2K.getCountryListItem($S2K.selectedCountryCode, CountryItemType.ENTRY);

            // Empty country list Container, and add entry item to it
            let countryListDiv = $('#' + $S2K.ID_COUNTRY_LIST_CONTAINER);
            countryListDiv.removeClass("list");
            countryListDiv.empty();
            countryListDiv.append(entryItemDiv);
        },

        /**
         * Load country list with only one entry item of current country
         */
        loadFullCountryList: function () {
            let countryListDiv = $('#' + $S2K.ID_COUNTRY_LIST_CONTAINER);
            let countryListboxDiv = $('<ul class="s2k-popup-country-listbox" role="listbox"></ul>');
            countryListDiv.addClass("list");
            // Empty country list Container and add list box of countries
            countryListDiv.empty();
            countryListDiv.append(countryListboxDiv);

            // Add selected item for current country, due to need show selected country in first line
            let selectedCountryDiv = $S2K.getCountryListItem($S2K.selectedCountryCode, CountryItemType.SELECTED);
            countryListboxDiv.append(selectedCountryDiv);

            // Generate country item for every country we support in a loop
            let countryList = getSupportCountryCodeList();
            countryList.forEach((countryCode) => {
                // Prevent from create duplicated item for selected country
                if (countryCode !== $S2K.selectedCountryCode) {
                    let unSelectedCountryDiv = $S2K.getCountryListItem(countryCode, CountryItemType.UNSELECTED);
                    countryListboxDiv.append(unSelectedCountryDiv);
                }
            });
        },

        /**
         * Get div of country piker list item
         * @param countryCode Country code of item
         * @param itemType The item type (current has 3 type: entry, selected, unselected)
         * @return {HTMLDivElement} Item of given item type and country code
         */
        getCountryListItem: function (countryCode, itemType) {
            // Based on country code get name and icon path of current country
            const countryName = getCountryName(countryCode);
            const countryIconPath = getCountryIconPath(countryCode);

            // The container div of current item
            const itemContainerDiv = $('<button class="s2k-popup-country-list-item"></button>');
            // Country icon div of current item
            const countryIconDiv = $('<img class="s2k-popup-country-icon" src="' + countryIconPath + '" alt="">');
            // Country name div of current item
            const countryNameDiv = $('<div class="s2k-popup-country-name">' + countryName + '</div>');

            // Add component to Container div
            itemContainerDiv.append(countryIconDiv);
            itemContainerDiv.append(countryNameDiv);

            // Config special layout of different type of item
            switch (itemType) {
                case CountryItemType.ENTRY:
                    // Add A11y focus to Entry item
                    itemContainerDiv.addClass("s2k-a11y-focus");
                    // Add A11y related tag to show this is an entry for a list box
                    itemContainerDiv.attr('aria-haspopup', 'listbox');
                    itemContainerDiv.attr('aria-expanded', 'false');
                    // Since there's no scrollbar for entry item, width need to be change
                    itemContainerDiv.addClass("entry");
                    // Arrow icon div of current item, only for the entry item in country picker
                    const arrowDiv = $('<img class="s2k-popup-country-down-arrow" src="/images/s2k-popup-chevron-down.svg" alt="">');
                    itemContainerDiv.append(arrowDiv);
                    // Add click function
                    itemContainerDiv.click($S2K.onCountryEntryItemClick);
                    break;
                case CountryItemType.SELECTED:
                    // Add A11y focus to selected item
                    itemContainerDiv.addClass("s2k-a11y-focus");
                    // Add A11y related tag to show this is a list item
                    itemContainerDiv.attr('role', 'option');
                    itemContainerDiv.attr('aria-selected', 'true');
                    // Change container style to selected
                    itemContainerDiv.addClass("s2k-popup-country-list-item-selected");
                    // Add click function
                    itemContainerDiv.click(function () {
                        // Report metrics
                        chrome.runtime.sendMessage({
                            action: "metrics-add-counter",
                            data: {
                                metricsName: MetricsNames["pop-country-list-cur-click"]
                            }
                        });
                        // Invoke the selected action
                        $S2K.onCountryItemClick();
                    });
                    break;
                case CountryItemType.UNSELECTED:
                    // Add A11y related tag to show this is a list item
                    itemContainerDiv.attr('role', 'option');
                    itemContainerDiv.attr('aria-selected', 'false');
                    // Add click function
                    itemContainerDiv.click(function () {
                        // Report metrics
                        chrome.runtime.sendMessage({
                            action: "metrics-add-counter",
                            data: {
                                metricsName: MetricsNames["pop-country-list-other-click"]
                            }
                        });
                        // Change the selected country first
                        $S2K.selectedCountryCode = countryCode;
                        // Invoke the selected action
                        $S2K.onCountryItemClick();
                    });
                    break;
            }
            return itemContainerDiv;
        },

        // ################################ Feedback Page ################################
        /**
         * Load settings page based on current feedback state
         * @param {"init" | "finish"} state Whether user finish feedback or not
         */
        loadFeedBackPage(state) {
            let initDiv = $('#' + $S2K.ID_FEEDBACK_INPUT_CONTAINER);
            let finishDiv = $('#' + $S2K.ID_FEEDBACK_FINISH_TEXT);
            let textArea = $('#' + $S2K.ID_FEEDBACK_TEXTAREA);
            // Set placeholder of textarea
            textArea.attr('placeholder', chrome.i18n.getMessage("popUpFeedbackPlaceholder"));
            // Reset textarea value
            textArea.val("");
            // Reset rating
            $S2K.rating = 0;
            if (state === "init") {
                $S2K.loadStars();
                // Show user input page if state is `init`
                initDiv.removeClass("s2k-hide");
                finishDiv.addClass("s2k-hide");
            } else {
                // Show finish text page if state is `finish`
                initDiv.addClass("s2k-hide");
                finishDiv.removeClass("s2k-hide");
                finishDiv.focus();
            }
        },

        /**
         * Load click action of rating stars in feedback page
         */
        loadStars() {
            let prefix = "s2k-popup-feedback-rate-star-";
            // Loop to add click action to each star
            for (let index = 1; index <= 5; index++) {
                let star = $('#' + prefix + index);
                // Set A11y of stars
                $S2K.setA11yofStars(0);
                // Reset all stars
                star.removeClass('active');
                star.on("click", function () {
                    //re-set A11y suffix
                    $S2K.setA11yofStars(index);
                    $S2K.onStarClick(index);
                });
            }
        },

        /**
         * Load click action of rating stars in feedback alert
         * @param selectedIndex The index of selected star
         */
        setA11yofStars(selectedIndex) {
            let prefix = "s2k-popup-feedback-rate-star-";
            // Loop to add click action to each star
            for (let index = 1; index <= 5; index++) {
                let star = $('#' + prefix + index);
                let starNameA11y = chrome.i18n.getMessage("A11yFeedbackRating") + index + chrome.i18n.getMessage("A11yFeedbackStar");
                let starSuffixA11y = chrome.i18n.getMessage("A11yFeedbackCurrentRating") + selectedIndex + chrome.i18n.getMessage("A11yFeedbackStar");
                star.attr("aria-label", starNameA11y + ", " + starSuffixA11y);
            }
        },

        /**
         * Handle click action of rating stars in feedback page
         * @param {int} index The index of clicked star
         */
        onStarClick(index) {
            let metricsName = MetricsNames["pop-feedback-star-click"] + index;
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: metricsName
                }
            });
            // Record the current rating
            $S2K.rating = index;
            let prefix = "s2k-popup-feedback-rate-star-";
            // Loop to add click action to each star
            for (let i = 1; i <= 5; i++) {
                let star = $('#' + prefix + i);
                if (i <= index) {
                    star.addClass('active');
                } else {
                    star.removeClass('active');
                }
            }
        },

        /**
         * Handle click action of submit button in feedback page
         */
        onSubmitFeedback() {
            let textArea = $('#' + $S2K.ID_FEEDBACK_TEXTAREA);
            // Metrics
            let starMetricsName = MetricsNames["pop-feedback-submit-click"] + $S2K.rating;
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: starMetricsName
                }
            });
            let textMetricsName = textArea.val().trim().length === 0 ? MetricsNames["pop-feedback-submit-empty"] : MetricsNames["pop-feedback-submit-input"];
            chrome.runtime.sendMessage({
                action: "metrics-add-counter",
                data: {
                    metricsName: textMetricsName
                }
            });
            // Submit feedback
            submitFeedback(textArea.val(), $S2K.rating, "PopUp", "");
            // Navigate to feedback finish page
            $S2K.loadFeedBackPage("finish");
            // Fix popup size based on the visible UI
            $S2K.resizePopup();
        },

        // ################################ Settings Page ################################
        /**
         * Load settings page:
         * 1. Request devices list.
         * 2. Load user preferences from local
         * @param {function()} completion Load complete call back
         */
        loadSettingsPage: function (completion) {
            // Set a semaphore to run completion until all config complete (total 2 tasks)
            let semaphore = 0;
            // Load user info
            $S2K.configUserInfoSection(function () {
                // Increase semaphore
                semaphore += 1;
                // Check if all config are complete
                if (semaphore > 1) {
                    completion();
                }
            });
            // `configAddToLibSection` need network request, need wait it complete
            $S2K.configAddToLibSection(function () {
                // Increase semaphore
                semaphore += 1;
                // Check if all config are complete
                if (semaphore > 1) {
                    completion();
                }
            });
        },

        /**
         * Config username and user current country
         * @param {function()} completion Config `User info` section finish call back
         */
        configUserInfoSection: function (completion) {
            let usernameDiv = $('#' + $S2K.ID_USERINFO_NAME_DIV);
            let countryDiv = $('#' + $S2K.ID_USERINFO_COUNTRY_DIV);
            // Set country image
            countryDiv.attr('src', getCountryIconPath($S2K.currentCountryCode));
            countryDiv.attr('aria-label', getCountryName($S2K.currentCountryCode));
            // Set username
            chrome.runtime.sendMessage({"action": "get-username"}, function (username) {
                usernameDiv.text(username);
                completion();
            });
        },

        /**
         * Request devices list and config UI based on the result
         * @param {function()} completion Config `Add to your library` section finish call back
         */
        configAddToLibSection: function (completion) {
            let container = $('#' + $S2K.ID_ADD_TO_LIB_SWITCHER_CONTAINER);
            let switcher = $('#' + $S2K.ID_ADD_TO_LIB_SWITCHER);
            switcher.attr('disabled', false);
            container.attr('disabled', false);
            // Request device list
            chrome.runtime.sendMessage({"action": "get-devices-list"}, function (devicesList) {
                $S2K.devicesList = devicesList || [];
                if ($S2K.devicesList.length === 0) {
                    // Show alert section if user has no device
                    $S2K.loadNoDevicesAlert();
                } else {
                    switcher.prop('checked', $S2K.isAddToLib);
                    // Set A11y status
                    container.attr("aria-checked", $S2K.isAddToLib);
                    // Config device list section based on the `add to lib` status
                    $S2K.configDeviceListSection();
                }
                // Callback after config
                completion();
            });
        },

        /**
         * Config device list section based on the current `add to your lib` status
         */
        configDeviceListSection: function () {
            // Handle the switcher status change
            if ($S2K.isAddToLib) {
                // Hide the devices list section
                let devicesSectionDiv = $('#' + $S2K.ID_DEVICES_LIST_SECTION_DIV);
                // Hide alert of no devices selected
                $S2K.hideNonDevicesSelectedAlert(true);
                devicesSectionDiv.addClass("s2k-hide");
            } else {
                // Show devices list section
                let devicesSectionDiv = $('#' + $S2K.ID_DEVICES_LIST_SECTION_DIV);
                devicesSectionDiv.removeClass("s2k-hide");
                // Load devices list
                $S2K.loadDevicesList();
            }
            // Since the current div size is changed, need to re-size body to match
            $S2K.resizePopup();
        },

        /**
         * Load the alert section if user has no device and disable the add-to-lib switcher
         */
        loadNoDevicesAlert: function () {
            // Update cache force archive on(1 case that user close archive and de-register device then open extension)
            $S2K.isAddToLib = true;
            chrome.runtime.sendMessage(
                {
                    action: "set-archive-switcher",
                    data: {archive: $S2K.isAddToLib}
                }
            );
            // Hide inline alert (Because there's no devices)
            $S2K.hideNonDevicesSelectedAlert(true);

            // Show devices list section
            let devicesSectionDiv = $('#' + $S2K.ID_DEVICES_LIST_SECTION_DIV);
            devicesSectionDiv.removeClass("s2k-hide");

            // disabled the add-to-lib switcher and its container
            let switcher = $('#' + $S2K.ID_ADD_TO_LIB_SWITCHER);
            let container = $('#' + $S2K.ID_ADD_TO_LIB_SWITCHER_CONTAINER);
            switcher.attr('disabled', true);
            container.attr('disabled', true);

            // Show no devices alert text
            let noDevicesTextDiv = $('#' + $S2K.ID_DEVICES_LIST_NO_DEVICE_TEXT);
            noDevicesTextDiv.removeClass("s2k-hide");
        },

        /**
         * Load devices list
         */
        loadDevicesList: function () {
            let devicesListDiv = $('#' + $S2K.ID_DEVICES_LIST_CONTAINER);
            // Empty devices list Container
            devicesListDiv.empty();

            // This temp list is to filter the device has been deregistered.
            let tempSelectedList = [];
            // Generate device item for each device user have
            $S2K.devicesList.forEach((device, index) => {
                let indexOfDevice = $S2K.selectedDevicesList.indexOf(device.deviceSerialNumber);
                let isSelected = false;
                if (indexOfDevice !== -1) {
                    // If the device is selected, change the status of check box
                    isSelected = true;
                    // Add it to temp list
                    tempSelectedList.push(device.deviceSerialNumber);
                }
                let deviceItemDiv = $S2K.getDevicesListItem(device, index, isSelected);
                devicesListDiv.append(deviceItemDiv);
            });
            // Use `tempSelectedList` to decide whether need to show inline alert
            // Because there's a case that user selected a device last time but de-registered it
            // `tempSelectedList` is a list that filtered the selected device list from cache that not in device list fetched remotely.
            $S2K.hideNonDevicesSelectedAlert(tempSelectedList.length > 0);
            // Refresh selected list based on the temp list
            $S2K.selectedDevicesList.forEach((device, index) => {
                let indexOfDevice = tempSelectedList.indexOf(device.deviceSerialNumber);
                if (indexOfDevice === -1) {
                    // if the Device is not in temp devices list, means it's deregistered, need to deleted from DB
                    chrome.runtime.sendMessage({
                        action: "delete-selected-device", data: {
                            deviceID: device.deviceSerialNumber,
                        }
                    });
                }
            });
        },

        /**
         * Change visibility of alert of `non devices are selected` and disable/enable send action related buttons
         * @param {boolean} hide Whether need to hide the inline alert
         */
        hideNonDevicesSelectedAlert: function (hide) {
            let inlineAlertDiv = $('#' + $S2K.ID_DEVICES_LIST_INLINE_ALERT);
            let cornerAlertDiv = $('#' + $S2K.ID_SETTINGS_CORNER_ALERT);
            let settingsBtn = $('#' + $S2K.ID_SETTINGS_BUTTON);
            let settingsIcon = $('#' + $S2K.ID_SETTINGS_ICON);
            if (hide) {
                // Hide inline alert
                inlineAlertDiv.addClass("s2k-hide");
                // Hide corner alert of settings button
                cornerAlertDiv.addClass("s2k-hide");
                // Remove additional margin and relative position for icon with alert
                settingsIcon.removeClass("s2k-popup-main-sub-item-corner-alert-container");
                // Remove Aira label to settings button for error alert
                settingsBtn.removeAttr('aria-label');
                // Enable send action related buttons
                $S2K.disableSendAction(false);
            } else {
                // Show inline alert
                inlineAlertDiv.removeClass("s2k-hide");
                // SHow corner alert of settings button
                cornerAlertDiv.removeClass("s2k-hide");
                // Add additional margin and relative position for icon with alert
                settingsIcon.addClass("s2k-popup-main-sub-item-corner-alert-container");
                // Set Aira label to settings button for error alert
                settingsBtn.attr('aria-label', chrome.i18n.getMessage("A11yPopupSettingsError"));
                // Disable send action related buttons
                $S2K.disableSendAction(true);
            }
        },

        /**
         * Get div of devices list item
         * @param device Device info
         * @param index The index of current device item
         * @param {boolean} isSelected Is the device selected
         * @return {HTMLDivElement} Item of given device
         */
        getDevicesListItem: function (device, index, isSelected) {
            // Based on country code get name and icon path of current country
            const deviceName = device.deviceName;

            // The container div of current item
            const itemContainerDiv = $('<div class="s2k-popup-settings-devices-list-item" tabindex="0"></div>');

            if (index === 0) {
                // Change top padding of first item
                itemContainerDiv.addClass("s2k-popup-settings-devices-list-item-first");
            } else if (index === $S2K.devicesList.length - 1) {
                // Change bottom padding of last item
                itemContainerDiv.addClass("s2k-popup-settings-devices-list-item-last");
            }
            // Check box of current item
            const deviceCheckBoxDiv = $('<input class="s2k-popup-settings-devices-list-checkbox" type="checkbox">');
            deviceCheckBoxDiv.prop("checked", isSelected);

            // set check
            deviceCheckBoxDiv.change(function () {
                if ($(this).is(':checked')) {
                    chrome.runtime.sendMessage({
                        action: "metrics-add-counter",
                        data: {
                            metricsName: MetricsNames["pop-setting-device-check"]
                        }
                    });
                    // Save the device as selected device, prevent from add same device multiple time
                    const index = $S2K.selectedDevicesList.indexOf(device.deviceSerialNumber);
                    if (index === -1) {
                        $S2K.selectedDevicesList.push(device.deviceSerialNumber);
                        chrome.runtime.sendMessage({
                            action: "add-selected-device", data: {
                                deviceID: device.deviceSerialNumber,
                            }
                        });
                    }
                } else {
                    chrome.runtime.sendMessage({
                        action: "metrics-add-counter",
                        data: {
                            metricsName: MetricsNames["pop-setting-device-uncheck"]
                        }
                    });
                    // Remove device from selected devices list
                    const index = $S2K.selectedDevicesList.indexOf(device.deviceSerialNumber);
                    if (index !== -1) {
                        $S2K.selectedDevicesList.splice(index, 1);
                        chrome.runtime.sendMessage({
                            action: "delete-selected-device", data: {
                                deviceID: device.deviceSerialNumber,
                            }
                        });
                    }
                }
                $S2K.hideNonDevicesSelectedAlert($S2K.selectedDevicesList.length > 0);
            });
            // Country name div of current item
            const deviceNameDiv = $('<div class="s2k-popup-settings-devices-list-name">' + $S2K.getTruncatedDeviceName(deviceName) + '</div>');

            // Add component to Container div
            itemContainerDiv.append(deviceCheckBoxDiv);
            itemContainerDiv.append(deviceNameDiv);
            return itemContainerDiv;
        },

        /**
         * Use a not visible div to test the length of device name, and truncated it to suitable length
         * @param {string} oriStr Original device name
         * @return {string} Truncated Device Name
         */
        getTruncatedDeviceName: function (oriStr) {
            // Get support not visible Div
            let testDiv = document.getElementById("s2k-popup-settings-devices-list-name-test");
            let newStr = oriStr;
            // Set device name to test div
            testDiv.textContent = newStr;
            // Get left sub string length and right substring length of original string
            let mid = Math.ceil(oriStr.length / 2);
            let leftLen = mid;
            let rightLen = mid;
            while (testDiv.offsetWidth > MAX_DEVICE_NAME_WIDTH) {
                // If the string makes the width test div longer than max, string need to be truncated, so we reduce left and right sub string length.
                // Need to skip "space" characters
                do {
                    leftLen --;
                } while (oriStr.charAt(leftLen - 1) === " ");
                do {
                    rightLen --;
                } while (oriStr.charAt(rightLen - 1) === " ");

                // Update new string with truncated left and right string with `...`
                newStr = oriStr.slice(0, leftLen) + "..." + oriStr.slice(-rightLen);
                // Reset the new string to test div and go next length check.
                testDiv.textContent = newStr;
            }
            return newStr;
        },

        // ################################ Spinner ################################
        /**
         * Change visibility of spinner in `popup window`
         * @param {boolean} hide Whether need to hide the spinner
         * @param {int} height The expected height of sinner view
         * @param {int} width The expected width of sinner view
         */
        hidePopupSpinner: function (hide, height = undefined, width = undefined) {
            let popUpWindow = $('#' + $S2K.ID_POP_UP);
            let popUpSpinnerWindow = $('#' + $S2K.ID_POP_UP_SPINNER_CONTAINER);
            if (hide) {
                // Hide spinner
                popUpSpinnerWindow.addClass("s2k-hide");
                // Show pop up window
                popUpWindow.removeClass("s2k-hide");
            } else {
                // Set the same spinner size as popup window
                popUpSpinnerWindow.height(height  ? height : popUpWindow.height());
                popUpSpinnerWindow.width(width  ? width : popUpWindow.width());
                // Hide pop up window
                popUpWindow.addClass("s2k-hide");
                // Show spinner
                popUpSpinnerWindow.removeClass("s2k-hide");
                $S2K.updateA11yFocus($S2K.ID_POP_UP_SPINNER_CONTAINER);
            }
        },

        /**
         * Change visibility of spinner in `log out section`
         * @param {boolean} hide Whether need to hide the spinner
         */
        hideSignOutSpinner: function (hide) {
            let signOutContentDiv = $('#' + $S2K.ID_SIGN_OUT_CONTENT_DIV);
            let signOutSpinnerDiv = $('#' + $S2K.ID_SIGN_OUT_SPINNER_DIV);
            if (hide) {
                // Hide spinner
                signOutSpinnerDiv.addClass("s2k-hide");
                // Show content
                signOutContentDiv.removeClass("s2k-hide");
            } else {
                // Hide content
                signOutContentDiv.addClass("s2k-hide");
                // Show spinner
                signOutSpinnerDiv.removeClass("s2k-hide");
                // Set focus
                $S2K.updateA11yFocus($S2K.ID_SIGN_OUT_SPINNER_DIV);
            }
        },

        // ################################ A11y ################################
        /**
         * Set A11y focus for a new window/page
         * @param {string} curDivID the window
         */
        updateA11yFocus(curDivID) {
            let signOutContentDiv = $('#' + curDivID);
            let focusEle = signOutContentDiv.find('.s2k-a11y-focus').first();
            focusEle.focus();
        }
    };


    // ################################ Initialize ################################
    $S2K.bootstrap();
});

